import { render } from "./Movie.vue?vue&type=template&id=9248b8ea"
import script from "./Movie.vue?vue&type=script&lang=js"
export * from "./Movie.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mli\\JTX\\ichioshiSK\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__